export const getRelativeRootOnLocalhost = (root: string) =>
    `${document.location.hostname === "localhost" ? "" : root}`;
